import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { cloneDeep } from 'lodash';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/data/constants/constants.enum';
import { GoalType } from 'src/app/data/constants/goal-type.const';
import { CampaignVO } from 'src/app/data/vo/CampaignVO';
import { environment } from 'src/environments/environment';
import { CampaignService } from '../../services/campaign.service';

@Component({
  selector: 'budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.scss']
})
export class BudgetComponent implements OnInit {

  @Input() group: FormGroup;
  @Input() isNew: boolean;
  showRecommendedBudgetMsg;
  goalTypes = GoalType;
  currencySymbol = environment.currencySymbol;
  minimumBudgetAmount = Constants.CAMAPIGN_BUDGET_MINIMUM;
  suggestedCampaignSubscription: Subscription;
  selectedSuggestedCampaignVO: CampaignVO;

  constructor(private campaignService: CampaignService) { }

  ngOnInit() {
    if (this.autoSelectControl.value === true) {
      this.goalTypeControl.patchValue(null);
    }
    this.suggestedCampaignSubscription = this.campaignService.getSuggestedCampaignUpdated().subscribe((cvo: CampaignVO) => {
      this.selectedSuggestedCampaignVO = cloneDeep(cvo);
    });
  }

  autoSelectChange($event) {
    if ($event.target && $event.target.checked) {
      if (this.selectedSuggestedCampaignVO && this.selectedSuggestedCampaignVO.goalType) {
        this.goalTypeControl.patchValue(null);
        this.campaignService.resetSuggestedCampaign(() => {
          this.autoSelectControl.setValue(true);
          this.goalTypeControl.patchValue(null);
        }, () => {
          this.autoSelectControl.setValue(false);
          this.goalTypeControl.patchValue(this.selectedSuggestedCampaignVO.goalType);
        });
      } else {
        this.autoSelectControl.setValue(true);
        this.goalTypeControl.patchValue(null);
      }
    } else {
      this.autoSelectControl.setValue(false);
    }
  }

  goalTypeChange($event) {
    if ($event.target && $event.target.checked) {
      if (this.selectedSuggestedCampaignVO && this.selectedSuggestedCampaignVO.goalType) {
        this.campaignService.resetSuggestedCampaign(() => {
          this.goalTypeControl.patchValue($event.target.value);
          this.autoSelectControl.setValue(false);
        }, () => {
          this.goalTypeControl.patchValue(this.selectedSuggestedCampaignVO.goalType);
        });
      } else {
        this.goalTypeControl.patchValue($event.target.value);
        this.autoSelectControl.setValue(false);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.suggestedCampaignSubscription) {
      this.suggestedCampaignSubscription.unsubscribe();
    }
  }

  get budgetControl(): FormControl {
    return this.group.get("budget") as FormControl;
  }

  get goalTypeControl(): FormControl {
    return this.group.get("goalType") as FormControl;
  }

  get autoSelectControl(): FormControl {
    return this.group.get("autoSelect") as FormControl;
  }


}
